import { cn } from '@iris/ui/lib/utils';

type Locale = 'fr' | 'ar';

/**
 * FR ↔ AR switch (US-C20). Each name is written in its own language and script, so it is recognisable
 * whatever the current UI language; the app re-renders without a reload.
 */
export function LanguageSwitch({
  value,
  onChange,
  label,
  names,
  className,
}: {
  value: Locale;
  onChange: (locale: Locale) => void;
  /** accessible name of the group, translated */
  label: string;
  names: Record<Locale, string>;
  className?: string;
}) {
  return (
    <div
      role="radiogroup"
      aria-label={label}
      className={cn('inline-flex rounded-lg border bg-muted p-1 text-sm', className)}
    >
      {(['fr', 'ar'] as const).map((locale) => (
        <button
          key={locale}
          type="button"
          role="radio"
          lang={locale}
          aria-checked={value === locale}
          onClick={() => onChange(locale)}
          className={cn(
            'min-h-9 rounded-md px-4 font-medium transition-colors duration-feedback',
            value === locale
              ? 'bg-background text-foreground shadow-1'
              : 'text-muted-foreground hover:text-foreground',
          )}
        >
          {names[locale]}
        </button>
      ))}
    </div>
  );
}
